import { ReactNode } from 'react';

import styles from './Leaderboard.module.css';

export const LeaderboardContainer = ({ children }: { children: ReactNode }) => {
  return <div className={styles.Leaderboard}>{children}</div>;
};
